import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { Caption1, RocketSmallIcon, SelectTrigger } from "@activecollab/components";
import PropTypes from "prop-types";
import { CallToUpgradeLink } from "~/components/CallToUpgradeLink/CallToUpgradeLink";
import TimeEstimatesPanel from "~/components/tasks/TaskPanel/TimeEstimatesPanel";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { PROJECT_TEMPLATE_TASK } from "../../utils";

export const TemplateTaskEstimatePicker = ({ task, onChange }) => {
  const { t } = useTranslation();
  const hasTaskEstimatesEnabled = useSelector((state) => getConfigOption(state, `task_estimates_enabled`));

  const handleChange = (estimate, job_type_id) => {
    onChange({ estimate: +estimate, job_type_id: +job_type_id });
  };

  return (
    <div className="tw-mb-6">
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-1">
        <Caption1 weight="bold">{t("Time Estimation")}</Caption1>
        {!hasTaskEstimatesEnabled ? (
          <CallToUpgradeLink
            ownerChildren={
              <Caption1
                as={RouterLink}
                color="theme-primary"
                weight="bold"
                className="tw-cursor-pointer tw-flex tw-items-center tw-justify-between tw-gap-1"
              >
                <RocketSmallIcon className="tw-fill-primary" />
                {t("Upgrade")}
              </Caption1>
            }
            memberChildren={
              <Caption1
                color="theme-primary"
                weight="bold"
                className="tw-cursor-pointer tw-flex tw-items-center tw-justify-between tw-gap-1"
              >
                <RocketSmallIcon className="tw-fill-primary" />
                {t("Upgrade")}
              </Caption1>
            }
            features={["task_estimates"]}
            context="Project Template Task Panel"
            page={PROJECT_TEMPLATE_TASK}
          />
        ) : null}
      </div>
      {hasTaskEstimatesEnabled ? (
        <TimeEstimatesPanel
          estimate={String(task.estimate)}
          jobTypeId={task.job_type_id}
          handleChange={handleChange}
          canEdit
        />
      ) : (
        <SelectTrigger
          className="tw-w-full"
          disabled
        >
          {t("Set...")}
        </SelectTrigger>
      )}
    </div>
  );
};

TemplateTaskEstimatePicker.propTypes = {
  task: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
